import { SupportRequest as _SupportRequest } from "@aidkitorg/aidkit/lib/application/support";
import { ToJson } from "@aidkitorg/types/lib/endpoints";
import { usePost } from "./API";
import { useState } from "react";
import { useAsyncEffect } from "./Hooks/AsyncEffect";

export type SupportRequest = ToJson<_SupportRequest>;

const caseStatuses = ["open", "resolved", "escalated"] as const;

const fields = [
  {
    key: "support_case_status",
    sortable: true,
  },
  {
    key: "assigned_to_name",
    sortable: true
  },
  {
    key: "case_created",
    sortable: true
  },
  {
    key: "source",
    sortable: false,
  },
  {
    key: "contact_methods",
    sortable: true,
  },
  {
    key: "applicant_stage",
    sortable: true
  },
  {
    key: "unhandled_messages",
    sortable: true,
  },
  {
    key: "max",
    sortable: true,
  },
  {
    key: "last_message_text",
    sortable: false,
  },
  {
    key: "tags",
    sortable: true,
  },
] as const;

const stages = ['No Application', 'In Progress', 'Applied'] as const;
const getStageFromRequest = (request: SupportRequest) => {
  if (request.dynamoApplicant) return 'In Progress';
  if (Object.keys(request.applicantInfos).length) return 'Applied';
  return 'No Application';
}

export type CaseStatus = typeof caseStatuses[number];
export type TableKey = typeof fields[number]['key'];
export type SupportApplicantStage = typeof stages[number];

export { caseStatuses, fields, getStageFromRequest, stages };

export function useRelatedCases(uid: string | undefined) {
  const getRelatedSupportCases = usePost('/applicant/related_cases');
  const [relatedSupportCases, setRelatedSupportCases] = useState<{ support_case: string; contact: string; channel: string }[]>([]);

  useAsyncEffect(async () => {
    if (!uid) return;
    const relatedSupportCases = await getRelatedSupportCases({
      applicant: uid,
    });
    setRelatedSupportCases(relatedSupportCases?.supportCases || []);
  }, [uid, getRelatedSupportCases]);

  return relatedSupportCases;
}
